export default __webpack_public_path__ + "media/components/ParallaxCrayon/crayon_3-190e5a21b7153eb8bdb7a2246e323078.png";